var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStickupCamEncrypted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 31 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 20.8V6H4v20h11.1a8 8 0 012.9-5.2zM11 16a3 3 0 110-6 3 3 0 010 6zM29 30v-3a6 6 0 10-12 0v3a2 2 0 00-2 2v6a2 2 0 002 2h12a2 2 0 002-2v-6a2 2 0 00-2-2zm-10-3a4 4 0 118 0v3h-8v-3zm10 11H17v-6h12v6z",
    fill: "#1998D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 0H1a1 1 0 00-1 1v32a1 1 0 001 1h6v4H1a1 1 0 000 2h10a1 1 0 000-2H9v-4h2a1 1 0 000-2H2V2h18v16a1 1 0 002 0V1a1 1 0 00-1-1z",
    fill: "#1998D5"
  })));
}
export default SvgStickupCamEncrypted;